var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "event", attrs: { column: "" } },
    [
      _c(
        "v-flex",
        {
          staticClass: "primary--text event-line",
          attrs: { xs12: "", sm12: "" }
        },
        [
          _c(
            "v-layout",
            { attrs: { "align-center": "" } },
            [
              _c(
                "v-avatar",
                { attrs: { size: "30" } },
                [
                  _c("v-icon", { attrs: { size: "20" } }, [
                    _vm._v("cloud_upload")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "ml-2 font-weight-bold" }, [
                _vm._v("Uploading a file ...")
              ]),
              _vm._v(" "),
              false
                ? _c("span", { staticClass: "ml-2 font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.event.userDisplayName))
                  ])
                : _vm._e(),
              _vm._v(" "),
              false
                ? _c("span", { staticClass: "pl-2 font-weight-light" }, [
                    _vm._v("[" + _vm._s(_vm.userCompanyName) + "] commented")
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "event-line ml-1 pl-4 pr-4 mr-1",
          attrs: { xs12: "", sm12: "", "align-center": "" }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.event.percent) + "%\n    "),
          _c("v-progress-linear", {
            staticClass: "mt-0 pt-0",
            model: {
              value: _vm.event.percent,
              callback: function($$v) {
                _vm.$set(_vm.event, "percent", $$v)
              },
              expression: "event.percent"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0957be0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0957be0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeline/UploadProgressEvent.vue
// module id = null
// module chunks = 